let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hE5eI")).then(() => parcelRequire('9rMVR'));